import PropTypes from "prop-types";
import React from "react";
import {faIcons} from "../../../../utils/iconConstants";

const StoreClosedIcon = ({date, storeClosures}) => {
    const isStoreClosedOnDate = storeClosures?.some(storeClosure =>
        date >= storeClosure.startDate && (!storeClosure.endDate || date <= storeClosure.endDate));

    return <>{isStoreClosedOnDate && <i id={'store-closed'}
                                        data-testid={'store-closed-icon'}
                                        className={`${faIcons.storeSlash} store-closure-color cell-font-icon`}/>}</>
}


StoreClosedIcon.propTypes = {
    date: PropTypes.string.isRequired,
    storeClosures: PropTypes.arrayOf(PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string
    }))
}

export default StoreClosedIcon